import { combineReducers } from 'redux'
import daten from './daten'
import konfiguration from './konfiguration'

const reducerMaster = combineReducers({
  daten,
  konfiguration,
})

export default reducerMaster
